import { Box, SxProps, Theme, Typography } from '@mui/material';

import DSIcon from './../../../datascope-icon.png';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    zIndex: (theme) => theme.zIndex.drawer + 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    '@keyframes spin': {
      '0%': { transform: 'rotate(360deg)' },
      '100%': { transform: 'rotate(0deg)' },
    },
    '& img': {
      marginBottom: '10px',
      animation: 'spin 4s linear infinite',
      height: '140px',
      width: '140px',
    },
  },
  message: {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 500,
    color: '#3B3C40',
  },
};

export function Loader({ message }: { message?: string }) {
  return (
    <Box sx={customStyles.root}>
      <img
        src={DSIcon}
        alt='DataScope loader'
      />
      {message && <Typography sx={customStyles.message}>{message}</Typography>}
    </Box>
  );
}
